import i18next from "i18next";
import { toast } from "react-toastify";
import { unauthorizedUserAccessKey } from "../constants/serverResponse/serverResponse.constants";

const showError = (message) => customToast(message, toast.error);

const showSuccess = (message) => customToast(message, toast.success);

// Helper function to process and translate parts of the message
const processBoatTypeMessage = (message) => {
  // Define regex patterns for extracting the three parts
  const startPattern = /^sport_with_boat_type_/;
  const endPattern = /_already_exists_with_higher_or_equal_level$/;
  const middlePattern = /\[(.*?)\]/; // Match content between "[" and "]"

  // Extract the first, middle, and last parts
  const startMatch = message.match(startPattern);
  const middleMatch = message.match(middlePattern);
  const endMatch = message.match(endPattern);

  // Translate the first and last parts
  const startTranslated = startMatch ? i18next.t(startMatch[0]) : "";
  const endTranslated = endMatch ? i18next.t(endMatch[0]) : "";

  let middleTranslated = "";
  if (middleMatch && middleMatch[1]) {
    // Split boat types by comma, translate each, and reassemble them
    middleTranslated = middleMatch[1]
      .split(",")
      .map((type) => i18next.t(type.trim()))
      .join(", ");
  }

  // Combine the parts with proper spacing
  return `${startTranslated} ${middleTranslated} ${endTranslated}`;
};

const customToast = (AllErrorMessages, toaster) => {
  const toastId = "user-not-active"; // Unique ID for "User is not active" message
  const boatTypeErrroPatternCheck =
    /^sport_with_boat_type_.*\[.*\].*_already_exists_with_higher_or_equal_level$/;

  if (Array.isArray(AllErrorMessages)) {
    AllErrorMessages.forEach((message) => {
      // Check if message matches pattern, then process only those that match
      const processedMessage = boatTypeErrroPatternCheck.test(message)
        ? processBoatTypeMessage(message)
        : i18next.t(message);

      if (message === unauthorizedUserAccessKey) {
        if (!toast.isActive(toastId)) {
          toaster(processedMessage, { toastId });
        }
      } else {
        toaster(processedMessage);
      }
    });
  } else {
    // Check if message matches pattern, then process only those that match
    const processedMessage = boatTypeErrroPatternCheck.test(AllErrorMessages)
      ? processBoatTypeMessage(AllErrorMessages)
      : i18next.t(AllErrorMessages);

    if (AllErrorMessages === unauthorizedUserAccessKey) {
      if (!toast.isActive(toastId)) {
        toaster(processedMessage, { toastId });
      }
    } else {
      toaster(processedMessage);
    }
  }
};

export const ToastifyService = {
  showError,
  showSuccess,
};
